import { EmailInbox } from './EmailInbox';

export default function IncomingEmails(props) {
  return (<EmailInbox inboxType="incoming" props={props}/>)
}
